import { Environment, PRESET_ENVIRONMENTS } from "./types";

const KEY_STORE = "hpac.apiKey";
const ENV_STORE = "hpac.env";
const CUSTOM_ENV_STORE = "hpac.customEnv";
const DRY_RUN_STORE = "hpac.dryRun";

export function getApiKey(): string {
  return sessionStorage.getItem(KEY_STORE) ?? "";
}

export function setApiKey(key: string) {
  if (key) {
    sessionStorage.setItem(KEY_STORE, key);
  } else {
    sessionStorage.removeItem(KEY_STORE);
  }
}

export function forgetEverything() {
  sessionStorage.removeItem(KEY_STORE);
  sessionStorage.removeItem(ENV_STORE);
  sessionStorage.removeItem(CUSTOM_ENV_STORE);
  sessionStorage.removeItem(DRY_RUN_STORE);
}

export function getActiveEnvironment(): Environment {
  const id = sessionStorage.getItem(ENV_STORE);
  const found = PRESET_ENVIRONMENTS.find(e => e.id === id);
  if (found) return found;

  if (id === "custom") {
    const raw = sessionStorage.getItem(CUSTOM_ENV_STORE);
    if (raw) {
      try {
        const parsed = JSON.parse(raw) as { baseUrl: string };
        if (parsed.baseUrl) {
          return { id: "custom", label: "Custom", baseUrl: parsed.baseUrl, preset: false };
        }
      } catch {
        /* ignore */
      }
    }
  }

  return PRESET_ENVIRONMENTS[0];
}

export function setEnvironment(env: Environment) {
  sessionStorage.setItem(ENV_STORE, env.id);
  if (!env.preset) {
    sessionStorage.setItem(CUSTOM_ENV_STORE, JSON.stringify({ baseUrl: env.baseUrl }));
  }
}

export function getDryRun(): boolean {
  return sessionStorage.getItem(DRY_RUN_STORE) === "1";
}

export function setDryRun(on: boolean) {
  sessionStorage.setItem(DRY_RUN_STORE, on ? "1" : "0");
}

const HPAC_HOST_PATTERN = /(^|\.)hpac-uk\.org$/i;

export function isTrustedBaseUrl(baseUrl: string): boolean {
  try {
    const u = new URL(baseUrl);
    if (u.hostname === "localhost") return true;
    if (u.hostname === "127.0.0.1") return true;
    return HPAC_HOST_PATTERN.test(u.hostname);
  } catch {
    return false;
  }
}
